import { useEffect, useState } from "react";
import { ServiceApi } from "../../services/index.service";
import { useSelector } from "react-redux";
const initialDataItem = {
  vchFieldName: "",
  vchFieldValue: "",
  vchFieldType: "static",
  isStaticFirst: true,
  staticValue: "",
  dynamicValue: "",
};
const useVendorFields = (props) => {
  const {  storage } = useSelector((state) => state);
  const [Loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [fieldsData, setFeildsData] = useState([]);
  const [dynamicDBValues, setDynamicDBValues] = useState([]);
  const [dataItem, setDataItem] = useState(initialDataItem);
  const serviceapi = new ServiceApi();

  useEffect(() => {
    fetchAllApis();
  }, []);

  const fetchAllApis = async () => {
    setLoading(true);
    await fetchFieldItems();
    await fetchDynamicDBValues();
    setLoading(false);
  };

  const handleChange = (name, value) => {
    if (name === "vchFieldType") {
      setDataItem({
        ...dataItem,
        [name]: value,
        vchFieldValue: "",
        staticValue: "",
        dynamicValue: "",
      });
    } else {
      setDataItem({ ...dataItem, [name]: value });
    }
  };

  const fetchFieldItems = async () => {
    const res = await serviceapi.getFieldsByVendorId(
      props?.selectedItem?.intVendorGatewayID
    );
    setFeildsData(res?.data);
  };

  const fetchDynamicDBValues = async () => {
    const intStoreID = storage?.store?.intStoreID;
    const res = await serviceapi.getDynamicDBValues(intStoreID);
    let response = [];
    if (res?.data?.[0]) {
      response = Object.keys(res?.data?.[0]);
    }
    setDynamicDBValues(response);
  };

  const AddNewFields = async () => {
    if (dataItem?.vchFieldType === "both") {
      if (
        !dataItem?.vchFieldName?.trim() ||
        !dataItem?.staticValue?.trim() ||
        !dataItem?.dynamicValue?.trim()
      ) {
        return;
      }
    } else if (
      !dataItem?.vchFieldName?.trim() ||
      !dataItem?.vchFieldValue?.trim() ||
      !dataItem?.vchFieldType
    ) {
      return;
    }
    const req = {
      vchFieldName: dataItem?.vchFieldName,
      vchFieldValue: dataItem?.vchFieldValue,
      vchFieldType: dataItem?.vchFieldType,
      intVendorGatewayID: props?.selectedItem?.intVendorGatewayID,
      action: "add",
    };
    if(dataItem?.vchFieldType === "both"){
      if(dataItem?.isStaticFirst){
        req.vchFieldValue=`${dataItem?.staticValue}&#${dataItem?.dynamicValue}#`
      }else{
        req.vchFieldValue=`#${dataItem?.dynamicValue}#&${dataItem?.staticValue}`
      }
    }
    setBtnLoading(true)
    const res = await serviceapi.addNewFields(req);
    setBtnLoading(false)
    if (res) {
      await fetchFieldItems();
      setDataItem(initialDataItem);
    }
  };

  const handleDeleteField = async (id) => {
    const res = await serviceapi?.deletevendorField(id);
    if (res) {
      await fetchFieldItems();
    }
  };
  return {
    Loading,
    fieldsData,
    handleChange,
    dataItem,
    dynamicDBValues,
    AddNewFields,
    handleDeleteField,
    btnLoading
  };
};

export default useVendorFields;
